var Shopify = Shopify || {};
(Shopify.money_format = "${{amount}} USD"),
    (Shopify.formatMoney = function (cents, format) {
        typeof cents == "string" && (cents = cents.replace(".", ""));
        var value = "",
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || this.money_format;
        function defaultOption(opt, def) {
            return typeof opt == "undefined" ? def : opt;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            if (
                ((precision = defaultOption(precision, 2)),
                (thousands = defaultOption(thousands, ",")),
                (decimal = defaultOption(decimal, ".")),
                isNaN(number) || number == null)
            )
                return 0;
            number = (number / 100).toFixed(precision);
            var parts = number.split("."),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                cents2 = parts[1] ? decimal + parts[1] : "";
            return dollars + cents2;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
        }
        return formatString.replace(placeholderRegex, value);
    });
//# sourceMappingURL=/cdn/shop/t/117/assets/shopify-money.js.map?v=90222061867881325521715756462
